import { Component, Inject, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { map, switchMap, startWith } from 'rxjs/operators';
import { FormBuilder,FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, Params } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { MatDialog, MatDialogRef } from '@angular/material';

import { HomeService } from 'app/main/service/home.service';
import { SeaportService } from 'app/main/service/seaport.service';
import { ContainerModalFormDialogComponent } from './container-modal/container-modal-form.component';
import { GoogleMapsAPIWrapper, AgmMap, LatLngBounds, AgmPolylinePoint, LatLngBoundsLiteral} from '@agm/core';
declare var google:any;

import { DatePipe } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { DatabaseService } from 'app/main/service/firebase-database.service';
import { AuthService } from 'app/auth.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { GoogleSheetService } from 'app/main/service/google-sheet.service';

import { UserSearchService } from 'app/main/service/user-search.service';

@Component({
    selector   : 'home-2',
    templateUrl: './home-2.component.html',
    styleUrls  : ['./home-2.component.scss'],
    animations : fuseAnimations
})
export class Home2Component implements OnInit, OnDestroy, AfterViewInit
{
    shortcut;
    today;
    @ViewChild('AgmMap') agmMap: AgmMap;
    map;
    polyline:Array<any>;
    name;

    seaport: any[];
    country: any[];
    unitType: any[];
    currency: any[];
    unitPrice: any[];
    filteredCountry1;
    filteredCountry2;
    filteredPort1;
    filteredPort2;
    dialogRef: any;
    errorMessage = '';
    x = 16.12116922405386;
    y = 108.21703878264134;
    pol;
    pod;
    col;
    cod;
    viewGoogleMap = true;
    requestProcessing = false;
    check = false;
    doSearch = false;
    resultLength;
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {HomeService} homeService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder, 
        private homeService: HomeService,
        private seaportService: SeaportService,
        private _matDialog: MatDialog,
        public gMaps: GoogleMapsAPIWrapper,
        public router: Router,
        private datePipe: DatePipe,
        private elementRef:ElementRef,
        @Inject(DOCUMENT) document,
        private databaseService: DatabaseService,
        private authService: AuthService,
        private userSearchService: UserSearchService
    )
    {
        this.name = this.authService.name
        // Register the custom chart.js plugin
        this._unsubscribeAll = new Subject();
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: this.name == "Guest"
                },
                toolbar  : {
                    hidden: false
                },
                footer   : {
                    hidden: false
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        
        this.homeService.onHomeChanged.pipe(takeUntil(this._unsubscribeAll))
            .subscribe(data => {
                this.seaport = data[0];
                this.country = data[1];
                this.unitType = data[2];
                this.currency = data[3];
                this.unitPrice = data[4];
                this.filteredCountry1 = this.country.slice();
                this.filteredPort1 = this.seaport.slice();
                this.filteredCountry2 = this.country.slice();
                this.filteredPort2 = this.seaport.slice();

                // login success
                if(this.authService.profile != 0) {
                    let id = this.authService.profile
                    this.homeService.getSearchFclPrice(id).then(val => {
                        let length = val.length;
                        for(let i = 0; i < length; i++){
                            val[i].map(item => {
                                item.pol = this.seaport.find(a => a.id == item.pol);
                                item.pod = this.seaport.find(a => a.id == item.pod);
                                item.unit = this.unitPrice.find(a => a.id == item.unit);
                                item.currency = this.currency.find(a => a.id == item.currency);
                            });
                        }
                        this.shortcut = val;
                        this.homeService.shortcut = val;
                    }).catch (err => console.error(err));
                }
            });
        this.resultLength = this.homeService.result.length;
        this.today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    }
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
    ngAfterViewInit() {
        this.agmMap.mapReady.subscribe(map => {
            this.map = map;
        });
    }
    setPol(e){
        this.homeService.pol = e;
        this.pol = e;
        this.viewGoogleMap = true;
        this.checkPort();
    }
    setPod(e){
        this.homeService.pod = e;
        this.pod = e;
        this.viewGoogleMap = true;
        this.checkPort();
    }
    onSearchSubmit(obj){
        let etd = this.datePipe.transform(new Date(obj.etd), 'yyyy-MM-dd');
        this.requestProcessing = true;
        this.homeService.getSearchData(etd).then(data =>{
            this.requestProcessing = false;
            this.resultLength = data[0].length; 
            this.doSearch = true;
            let type = obj.type;
            let search = {
                pol: this.pol.name,
                polId: this.pol.id,
                pod: this.pod.name,
                podId: this.pod.id,
                etd: etd,
                type: type,
                searchResult: this.resultLength
            };
            this.homeService.search = search;
            let url = '/landingpage/result/' + this.pol.id + '/' + this.pod.id + '/' + etd;
            if(this.authService.name == "Guest"){
                this.authService.searchData = search;
                this.authService.goUrl = url;
                this.router.navigate(['/authentication/login-2']);
            } else {
                this.router.navigate([url]);
            }
        }).catch(err => {
            this.requestProcessing = false;
            console.error(err);
            alert('error!');
        });
    }
    getResultByShortcut(obj){
        let validity = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        let search = {
            pol: obj[0].pol.name,
            polId: obj[0].pol.id,
            pod: obj[0].pod.name,
            podId: obj[0].pod.id,
            etd: validity,
            type: '1x20DC',
            searchResult: obj.length
        };
        this.userSearchService.createUserSearch(search);
        this.router.navigate(["/landingpage/result/" + obj[0].pol.id + "/" + obj[0].pod.id + "/" + validity]);
    }
    private checkPort(){
        if(this.pol && this.pod){
            const bounds: LatLngBounds = new google.maps.LatLngBounds();
            bounds.extend(new google.maps.LatLng(this.pol.info.coords.lat, this.pol.info.coords.lng));
            bounds.extend(new google.maps.LatLng(this.pod.info.coords.lat, this.pod.info.coords.lng));
            this.map.fitBounds(bounds);
            this.polyline = this.rebuildPolyline();
        } else {
            if(this.pol) {
                this.x = this.pol.info.coords.lat;
                this.y = this.pol.info.coords.lng;
            }
            if(this.pod) {
                this.x = this.pod.info.coords.lat;
                this.y = this.pod.info.coords.lng;
            }
        }
    }
    private rebuildPolyline() {
        let polyline = [];
        if(this.pol && this.pod){
            polyline.push(this.pol.info.coords);
            polyline.push(this.pod.info.coords);
        }
        return polyline;
    }
}